import { HomeContentBlocks } from "@app/layouts/Home/Elements/utils";
import { TeaserData } from "@app/types/ServerCustomContext";
import { configVideoOverlayPortrait } from "@pub/config";
import {
  BreadCrumbs,
  Button,
  ResponsiveIframe,
  Typography,
  useBodyScrollLock,
} from "@sphtech/dmg-design-system";
import { useState } from "react";
import { createPortal } from "react-dom";

import Strip from "./Strip";
import { exitIcon } from "./utils";
import styles from "./videooverlayportrait.module.css";

const { Heading } = Typography;

type Props = {
  content?: HomeContentBlocks;
};

/**
 * There are 2 parts to the VideoOverlayPortrait
 * - Strip of portrait videos OUTSIDE overlay
 * - Overlay with Stage AND Strip of portrait videos
 */
const VideoOverlayPortrait = ({ content }: Props) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [stageItem, setStageItem] = useState<TeaserData | null>(null);

  useBodyScrollLock(showOverlay);

  if (!content) return null;

  return (
    <div className={styles.videoOverlayPortrait}>
      <div className={styles.headingTitle}>
        <Heading.SubSectionTitle nameZH={content.titleZH}>
          {content.title}
        </Heading.SubSectionTitle>
      </div>

      <Strip
        content={content}
        itemWidth={320}
        itemHeight={560}
        setShowOverlay={setShowOverlay}
        setStageItem={setStageItem}
      />

      {showOverlay &&
        createPortal(
          <section className={styles.overlay}>
            <div className={styles.stage}>
              <div className={styles.info}>
                <div className={styles.sectionLabel}>
                  <BreadCrumbs sections={stageItem?.sections || []} />
                </div>

                <h2 className={styles.title}>{stageItem?.title}</h2>
                <p className={styles.desc}>{stageItem?.description}</p>

                <Button variant="tertiary" href={stageItem?.path}>
                  {configVideoOverlayPortrait.stageButtonText || "View More"}
                </Button>
              </div>

              <div className={styles.iframeContainer}>
                <ResponsiveIframe
                  forceAspectRatio={16 / 9}
                  src={stageItem?.embedUri || ""}
                  loading="lazy"
                />
              </div>
            </div>

            <button
              onClick={() => {
                setShowOverlay(false);
              }}
              className={styles.exitButton}
            >
              {exitIcon}
            </button>

            <div className={styles.stageBottom}>
              <Strip
                content={content}
                itemWidth={360}
                itemHeight={240}
                setShowOverlay={setShowOverlay}
                setStageItem={setStageItem}
              />
            </div>
          </section>,
          document.body,
        )}
    </div>
  );
};

export default VideoOverlayPortrait;
